import { api } from "@/lib/api"
import type { Property, PropertyPhoto, Document } from "@rentbase/shared"

export const propertiesService = {
  async list(): Promise<Property[]> {
    const { data } = await api.get("/api/properties")
    return data.data
  },
  async get(id: string): Promise<Property> {
    const { data } = await api.get(`/api/properties/${id}`)
    return data.data
  },
  async create(input: Record<string, unknown>): Promise<Property> {
    const { data } = await api.post("/api/properties", input)
    return data.data
  },
  async update(id: string, input: Record<string, unknown>): Promise<Property> {
    const { data } = await api.put(`/api/properties/${id}`, input)
    return data.data
  },
  async remove(id: string): Promise<void> {
    await api.delete(`/api/properties/${id}`)
  },
  async uploadPhotos(propertyId: string, files: File[]): Promise<PropertyPhoto[]> {
    const formData = new FormData()
    files.forEach((f) => formData.append("photos", f))
    const { data } = await api.post(`/api/properties/${propertyId}/photos`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    return data.data
  },
  async deletePhoto(propertyId: string, photoId: string): Promise<void> {
    await api.delete(`/api/properties/${propertyId}/photos/${photoId}`)
  },
  async setCoverPhoto(propertyId: string, photoId: string): Promise<PropertyPhoto> {
    const { data } = await api.put(`/api/properties/${propertyId}/photos/${photoId}/cover`)
    return data.data
  },
  async uploadDocument(propertyId: string, file: File): Promise<Document> {
    const formData = new FormData()
    formData.append("file", file)
    formData.append("entity_type", "property")
    formData.append("entity_id", propertyId)
    const { data } = await api.post("/api/documents/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    return data.data
  },
  async listDocuments(propertyId: string): Promise<Document[]> {
    const { data } = await api.get("/api/documents", {
      params: { entity_type: "property", entity_id: propertyId },
    })
    return data.data
  },
  async deleteDocument(docId: string): Promise<void> {
    await api.delete(`/api/documents/${docId}`)
  },
}
